/**
 * Coupling WNC-specific wrapper for the shared StripePaymentsSection.
 * Re-exports the shared component with site-specific framing.
 */
import React from 'react';
import { StripePaymentsSection as SharedStripePaymentsSection, HARDWARE_FRAMING as hardwareFraming } from '@coupling/ui/hardware';

export const StripePaymentsSection: React.FC<{
  id?: string;
  heading?: string;
  className?: string;
}> = (props) => (
  <SharedStripePaymentsSection {...props} hardwareFraming={hardwareFraming} />
);

export default StripePaymentsSection;
